module.exports = __webpack_public_path__ + "static/media/PTMono-Regular.f0d5d133.woff2";